module.exports = __webpack_public_path__ + "img/Go-Back.d7f432e4.svg";